import React from 'react';

interface ProgressBarProps {
  min: number;
  max: number;
  value: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ min, max, value }) => {
  const percentage = ((value - min) / (max - min)) * 100;

  return (
    <div className={`h-1.5 w-full rounded-full bg-[#939BA4]`}>
      <div className="h-1.5 rounded-full bg-primary" style={{ width: `${percentage}%` }}></div>
    </div>
  );
};

export default ProgressBar;
